import React, { PureComponent } from 'react';
import { Translate } from 'react-localize-redux';
import { Link } from 'gatsby';
import styled from 'styled-components';

import Button from '../../components/button';
import QandAList from '../q-and-a-list';
import { InformationHeading } from './heading';

/**
 * Number of FAQs to display
 * Must correspond with locale file
 */
const numOfDefault = 4;

const Container = styled.div``;

const MoreLink = styled(Link)`
  width: 17em;
  display: block;
  margin: 2em auto 0;
`;

/**
 * Faq section
 */
class Faq extends PureComponent {
  render() {
    const { gameId } = this.props;
    return (
      <Container>
        <InformationHeading style={{ marginBottom: '2em' }}>
          <Translate id="landingPage.faq.subtitle" />
        </InformationHeading>
        <QandAList
          maxLength={numOfDefault}
          paths={[`/faqs/gameSpecific/${gameId}`, '/faqs/general']}
        />
        <MoreLink to={`/games/${gameId}/faqs/`}>
          <Button>
            <Translate id="landingPage.faq.allButton" />
          </Button>
        </MoreLink>
      </Container>
    );
  }
}

export default Faq;
